/* @generated */

// src/assets/ui-icon/line/file-history.tsx
import * as React from "react";
var FileHistoryLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M7 18.5v-13h7V8h2.5v4.021c.165-.012.33-.021.5-.021.335.001.669.027 1 .078V7.62a2.265 2.265 0 0 0-.659-1.591l-1.372-1.371A2.265 2.265 0 0 0 14.38 4H5.5v16h6.509a5.718 5.718 0 0 1-.431-1.5H7Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M17 13.5c-2.379 0-4 1.45-4 4s1.621 4 4 4 4-1.45 4-4-1.621-4-4-4Zm.5 4.5H15v-1h1.5v-2h1v3Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  FileHistoryLine
};
